'use client'

import { createContext, useContext } from 'use-context-selector'
import Cookies from 'js-cookie'
import { ReactNode, useEffect, useState } from 'react'
import { getScopedResources } from '@/fe-common/utils'
import type { ProjectScopeType } from '@/fe-common'
import { ALL_RESOURCES } from '@/models/permission_data'

export type ResourceContextValue = ScopedResource & {
  ALL_RESOURCES: string[]
}

export type ScopedResource = {
  domain: string[]
  system: string[]
  user: string[]
}

export const ResourceContext = createContext<ResourceContextValue>({
  domain: [],
  system: [],
  user: [],
  ALL_RESOURCES: [],
})

type IResourceProviderProps = {
  children: React.ReactNode
}

export const ResourceProvider = ({ children }: IResourceProviderProps) => {
  const [currentScope, setCurrentScope] = useState<ProjectScopeType>('project')
  const [scopedResources, setScopedResources] = useState<ScopedResource>({
    domain: [],
    system: [],
    user: [],
  })
  useEffect(() => {
    setCurrentScope(Cookies.get('scope') as ProjectScopeType)
  }, [])

  useEffect(() => {
    getScopedResources().then(data => {
      setScopedResources(data)
    })
  }, [currentScope])

  return (
    <ResourceContext.Provider value={{ ...scopedResources, ALL_RESOURCES }}>
      {children}
    </ResourceContext.Provider>
  )
}

export const VoidResourceProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ResourceContext.Provider
      value={{ domain: [], system: [], user: [], ALL_RESOURCES: [] }}>
      {children}
    </ResourceContext.Provider>
  )
}

export const useResourceContext = () => useContext(ResourceContext)
